export default __webpack_public_path__ + "locales/pt-BR/PortalUnavailable.json?hash=990882c8caa686bbd0c7fe35294c283a";